<div class="header" header>
    <div class="top">
        <h2>{{ 'admin.request-history.request-history-table.title' | translate }}</h2>
        <app-report-download-form
            [tableConfig]="tableConfig"
            [isLoading]="isLoadingDownload"
            (filterChange)="onFilterChange(tableFilters, $event)"
            (reportDownload)="onRequestsHistoryDownload($event)">
        </app-report-download-form>
    </div>
    <div class="bottom">
        <app-input placeholder="{{'admin.tools.table.columns.toolName' | translate}}"
                   [(ngModel)]="toolName" (inputChange)="onNameChanged()">
        </app-input>
        <app-input [placeholder]="'admin.tools.table.columns.toolUid' | translate"
                   [(ngModel)]="toolUid" (inputChange)="onUidChanged()"></app-input>

    </div>
</div>
<div class="body" body>
    <app-tool-request-history-table
        [toolRequestHistory]="toolRequestHistory"
        [isLoading]="isLoadingRequestsHistory"
        [tableConfig]="tableConfig"
        [hasTitle]="false"
        [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
        (sortChange)="onSortChange($event)"
        (pageChange)="onPageChange($event)"
        (rowClick)="onTableRowClick($event)"
        (filterChange)="onFilterChange($event.filters, reportFilters)">
    </app-tool-request-history-table>
</div>
<app-pending-tool-requests-modal label='lineSetter.tool-returns.pages.toolRequest'>
</app-pending-tool-requests-modal>
